module.exports = __webpack_public_path__ + "media/images/flags/lang-e2f290a3f253131f59478a4dd7215e4c.svg";